// Voice Server WebSocket Endpoint (Cloudflare Tunnel 경유)
export const AGENT_WEBSOCKET_ENDPOINT =
  process.env.NEXT_PUBLIC_VOICE_WS_URL || "wss://voice.nova.ggls.dev/ws";